import { API_URL } from "./config";
import axios from "axios";
import { logTranscriptCache } from "../helpers/transcriptCacheLog";

const ANALYSIS_URL = `${API_URL}/analysis`;

interface AnalysisConfig {
  asset_description: string;
}
export interface AnalysisModel {
  project_id: string;
  ruleset_id: string;
  name: string;
  notes: string;
  asset_id?: string;
  config?: AnalysisConfig;
  status?: string;
  locale_code?: string;
  lang?: string;
}

export interface CampaignModel {
  name: string;
}

interface listAnalysesParams {
  sortingColumns: any;
  page?: number;
  pageSize?: number;
}

export const listAnalyses = async (
  {
    sortingColumns = {},
    page = 1,
    pageSize = 2000,
  }: listAnalysesParams
): Promise<any> => {
  const ordering = [];
  for (const [key, value] of Object.entries(sortingColumns)) {
    if (value === "asc" || value === "desc") {
      ordering.push(`${value === "asc" ? "" : "-"}${key}`);
    }
  }
  const params: any = {
    page: page.toString(),
    page_size: pageSize.toString(),
  };
  if (ordering.length > 0) {
    params["ordering"] = ordering.join(",");
  } else {
    params["ordering"] = "-created_at";
  }
  return  axios
    .get(ANALYSIS_URL, { params }).then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error list analyses", error);
      throw error;
    });  
};

export const getAnalysis = async (
  analysisId: string,
  retries: number = 0
): Promise<AnalysisModel> => {
  return axios
    .get(`${ANALYSIS_URL}/${analysisId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching analysis by ID:", error);
      throw error;
    });
};

export const createAnalysis = async (analysis: AnalysisModel): Promise<any> => {
  return axios
    .post(`${ANALYSIS_URL}/create`, analysis)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating analysis:", error);
      throw error;
    });
};

export const executeAnalysis = async (analysisId: string, lang_code: string): Promise<any> => {
  return axios
    .post(`${ANALYSIS_URL}/${analysisId}/trigger`,{lang_code})
    .then((response) => {
      logTranscriptCache("analysis", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error triggering analysis:", error);
      throw error;
    });
};

export const patchAnalysis = async (
  analysisId: string,
  updatedFields: Partial<AnalysisModel>
): Promise<any> => {
  try {
    const response = await axios.patch(
      `${ANALYSIS_URL}/${analysisId}`,
      updatedFields
    );
    return response.data;
  } catch (error) {
    console.error("Error patching analysis:", error);
    throw error;
  }
};

export const deleteAnalysis = async (analysisId: string): Promise<null> => {
  return axios
    .delete(`${ANALYSIS_URL}/${analysisId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error deleting analysis:", error);
      throw error;
    });
};

export const getAnalysisInIntervals = async (
  analysisId: string
): Promise<AnalysisModel> => {
  return new Promise((resolve, reject) => {
    let retires = 0;
    const maxRetries = 30;
      let callInInterval = setInterval(async () => {
        const response = await getAnalysis(analysisId, retires);
        retires++
        if (response.status === 'finished') {
          clearInterval(callInInterval);
          resolve(response);
        } else if (response.status === 'error') {
          clearInterval(callInInterval);
          reject(new Error('Asset processing failed'));
        } else if (retires >= maxRetries) {
          clearInterval(callInInterval);
          reject(new Error('Max retries reached'));
        }
      }, 15000);
    });
};
 